export default "__VITE_ASSET__Ds6Fvoj5__"